import React, { useEffect, useState } from 'react'
import whatsappApi from './whatsappApi'
import myToast from '../../Utils/MyToast'

const WhatsAppReportsPanel = () => {
  const [fromDate, setFromDate] = useState(() => {
    const d = new Date()
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-01`
  })
  const [toDate, setToDate] = useState(() => new Date().toISOString().slice(0, 10))
  const [category, setCategory] = useState('')
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)

  const load = async () => {
    setLoading(true)
    try {
      const res = await whatsappApi.getReports({
        from_date: fromDate,
        to_date: toDate,
        category: category || undefined,
      })
      if (res.api_status === 'OK') {
        setData(res.data)
      } else {
        myToast.notify_error(res.api_remark || 'Failed to load reports')
      }
    } catch (e) {
      myToast.notify_error('Failed to load reports')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    load()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const exportCsv = () => {
    const rows = data?.rows || []
    if (!rows.length) {
      myToast.notify_error('No rows to export')
      return
    }
    const headers = [
      'id',
      'recipient_number',
      'student_id',
      'status',
      'category',
      'cost_charged',
      'sent_at',
      'delivered_at',
      'created_at',
      'error_reason',
    ]
    const lines = [headers.join(',')]
    rows.forEach((r) => {
      lines.push(
        headers
          .map((h) => {
            const v = r[h] == null ? '' : String(r[h]).replace(/"/g, '""')
            return `"${v}"`
          })
          .join(',')
      )
    })
    const blob = new Blob([lines.join('\n')], { type: 'text/csv;charset=utf-8;' })
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = `whatsapp_report_${fromDate}_${toDate}.csv`
    a.click()
    URL.revokeObjectURL(url)
  }

  const s = data?.summary || {}

  return (
    <div style={{ padding: '12px 4px' }}>
      <div className="d-flex flex-wrap align-items-end mb-3" style={{ gap: 10 }}>
        <div>
          <label style={{ fontSize: 12, fontWeight: 600 }}>From</label>
          <input
            type="date"
            className="form-control form-control-sm"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
          />
        </div>
        <div>
          <label style={{ fontSize: 12, fontWeight: 600 }}>To</label>
          <input
            type="date"
            className="form-control form-control-sm"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
          />
        </div>
        <div>
          <label style={{ fontSize: 12, fontWeight: 600 }}>Category</label>
          <select
            className="form-control form-control-sm"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
          >
            <option value="">All</option>
            <option value="utility">Utility</option>
            <option value="marketing">Marketing</option>
            <option value="authentication">Authentication</option>
            <option value="service">Service</option>
          </select>
        </div>
        <button type="button" className="btn btn-sm btn-success" onClick={load} disabled={loading}>
          {loading ? 'Loading…' : 'Refresh'}
        </button>
        <button type="button" className="btn btn-sm btn-outline-secondary" onClick={exportCsv}>
          Export CSV
        </button>
      </div>

      <div className="row" style={{ maxWidth: 900, marginBottom: 16 }}>
        {[
          { label: 'Today', value: s.today_count ?? '—' },
          { label: 'Total (range)', value: s.total_messages ?? '—' },
          { label: 'Delivered %', value: s.delivered_pct != null ? `${s.delivered_pct}%` : '—' },
          { label: 'Failed %', value: s.failed_pct != null ? `${s.failed_pct}%` : '—' },
          { label: 'Cost spent', value: s.total_cost != null ? `₹${Number(s.total_cost).toFixed(2)}` : '—' },
        ].map((card) => (
          <div className="col-6 col-md-4 col-lg" key={card.label} style={{ marginBottom: 10 }}>
            <div
              style={{
                background: '#f8fafc',
                border: '1px solid #e2e8f0',
                borderRadius: 10,
                padding: '12px 14px',
              }}
            >
              <div style={{ fontSize: 12, color: '#64748b' }}>{card.label}</div>
              <div style={{ fontSize: 22, fontWeight: 800, color: '#0f172a' }}>{card.value}</div>
            </div>
          </div>
        ))}
      </div>

      <div className="table-responsive" style={{ maxWidth: 1000 }}>
        <table className="table table-sm table-bordered">
          <thead className="thead-light">
            <tr>
              <th>When</th>
              <th>To</th>
              <th>Student</th>
              <th>Status</th>
              <th>Category</th>
              <th>Cost</th>
            </tr>
          </thead>
          <tbody>
            {(data?.rows || []).length === 0 ? (
              <tr>
                <td colSpan={6} className="text-center text-muted">
                  No messages in range
                </td>
              </tr>
            ) : (
              (data.rows || []).map((r) => (
                <tr key={r.id}>
                  <td>{r.created_at}</td>
                  <td>{r.recipient_number}</td>
                  <td>{r.student_id || '—'}</td>
                  <td>{r.status}</td>
                  <td>{r.category}</td>
                  <td>₹{Number(r.cost_charged || 0).toFixed(4)}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default WhatsAppReportsPanel
